module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="app-history-modal">\n    <div class="app-history-modal__header app-history-modal__header--first">\n        <h2>\n            No problem. We\'ll skip this section for now but let\'s\n            <strong>set a reminder</strong> to upload your resume later.\n        </h2>\n    </div>\n\n    <div class="app-resume-reminder__form">\n        <select name="day">\n            ';
 days.forEach(function(day) { ;
__p += '\n                <option value="' +
__e( day.value ) +
'"';
 if (day.selected) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( day.display ) +
'</option>\n            ';
 }) ;
__p += '\n        </select>\n\n        <select name="time">\n            ';
 times.forEach(function(time) { ;
__p += '\n                <option value="' +
__e( time.value ) +
'"';
 if (time.selected) { ;
__p += ' selected';
 } ;
__p += '>' +
__e( time.display ) +
'</option>\n            ';
 }) ;
__p += '\n        </select>\n    </div>\n    <div class="app-resume-reminder__note">\n        We\'ll send you a text message and email to come back and finish\n    </div>\n\n    <div class="app-modal__actions">\n        <span><a href="#" class="btn btn-primary btn-large">Set Reminder</a></span>\n        <span><a href="#" class="js-skip">Skip reminder</a></span>\n        <span><a href="#" class="js-cancel">Actually, I\'ll add my work history manually</a></span>\n    </div>\n</div>\n';

}
return __p
}